<template>
  <div class="user-detail-group-orders">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailGroupOrdersInfo.orders" border style="width: 100%">
        <el-table-column prop="orderId" :label="$t('userDetailGroupOrders.orderId')" align="center">
        </el-table-column>
        <el-table-column :label="$t('userDetailGroupOrders.productImage')" align="center">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px; border-radius: 10px;" :src="scope.row.coverPhoto"
              :preview-src-list="[scope.row.coverPhoto]" fit="cover">
              <div slot="error" class="image-slot">
                <img src="/img/noPhoto.jpg" style="width:50px;height:50px;border-radius:10px;">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column :label="$t('userDetailGroupOrders.productName')" align="center">
          <template slot-scope="scope">
            【{{ scope.row.userCount }}{{ $t('userDetailGroupOrders.peopleGroup') }}】{{ scope.row.prodName }}
          </template>
        </el-table-column>
        <el-table-column prop="buyerName" :label="$t('userDetailGroupOrders.buyer')" align="center">
        </el-table-column>
        <el-table-column prop="groupBuyerName" :label="$t('userDetailGroupOrders.groupLeader')" align="center">
        </el-table-column>
        <el-table-column prop="buyerCount" :label="$t('userDetailGroupOrders.buyQuantity')" align="center">
        </el-table-column>
        <el-table-column :label="$t('userDetailGroupOrders.groupPeople')" align="center">
          <template slot-scope="scope">
            {{ scope.row.groupCount }}/{{ scope.row.userCount }}
          </template>
        </el-table-column>
        <el-table-column prop="groupPrice" :label="$t('userDetailGroupOrders.groupAmount')" align="center">
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('userDetailGroupOrders.status')" align="center">
        </el-table-column>
        <el-table-column prop="rebateAmount" :label="$t('userDetailGroupOrders.rebateAmount')" align="center">
        </el-table-column>
        <el-table-column prop="openTime" :label="$t('userDetailGroupOrders.openTime')" align="center">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('userDetailGroupOrders.groupTime')" align="center">
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('userDetailGroupOrders.deadline')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getGroupOrderList } from '@/api/user/userDetailGroupOrdersApi'

export default {
  name: 'UserDetailGroupOrders',
  data() {
    return {
      userDetailGroupOrdersInfo: {
        orders: [],
        buyerId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailGroupOrdersInfo.buyerId = data.userId
      this.loadGroupOrderData()
    },
    loadGroupOrderData() {
      const params = {
        buyerId: this.userDetailGroupOrdersInfo.buyerId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getGroupOrderList(params).then(res => {
        this.userDetailGroupOrdersInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadGroupOrderData()
    }
  }
}
</script>

<style scoped>
.user-detail-group-orders {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>